import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';

const Dashboards = ({ match }) => {
  const requestedUrl = match.url.replace(/\/$/, '');

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/kanban-board`} />
        <Route path={`${requestedUrl}/kanban-board`} component={lazy(() => import('./KanbanBoard'))} />
        <Route component={lazy(() => import('../Pages/404'))} />
      </Switch>
    </Suspense>
  );
};

export default Dashboards;
